import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';

import {
  memberDetailActions,
  selectCouponList,
  selectCouponListLoading,
  selectedIsDeletedAccount,
} from 'features/member/reducer/memberDetailSlice';

import { FIRST_PAGE_INDEX } from 'constants/common';

import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import AccordionBox from 'components/memberdetail/detail/AccordionBox';
import couponListColumnData from './couponListColumn';
import AddCouponModal from './addCouponModal';

import * as S from './CouponList.styled';

interface Props {
  userId: string;
}

const CouponList = ({ userId }: Props) => {
  const dispatch = useDispatch();

  const { items: couponList, totalPages, totalItems } = useSelector(selectCouponList);
  const couponListLoading = useSelector(selectCouponListLoading);
  const isDeletedAccount = useSelector(selectedIsDeletedAccount);

  const [couponModalOpen, setCouponModalOpen] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(FIRST_PAGE_INDEX);

  const onChangeDisplay = (event: React.ChangeEvent, expanded: boolean, name: string) => {
    if (expanded) {
      name === 'coupon' && dispatch(memberDetailActions.getCouponList({ userId }));
    }
  };

  const onChangeCouponListPage = (pageIndex: number) => {
    setCurrentPage(pageIndex);
    dispatch(memberDetailActions.getCouponList({ userId: userId, page: pageIndex }));
  };

  return (
    <>
      <AddCouponModal
        userId={userId}
        isOpen={couponModalOpen}
        closeModal={() => setCouponModalOpen(false)}
      />

      <AccordionBox
        title={'Coupon List'}
        margin={'15px 0 0 0'}
        onChangeDisplay={onChangeDisplay}
        name={'coupon'}
      >
        <DataTableLayout
          maxHeight={'300px'}
          upperButton={
            <Button
              size={'small'}
              variant={'contained'}
              color={'primary'}
              onClick={() => setCouponModalOpen(true)}
              disabled={isDeletedAccount}
            >
              Add Coupon
            </Button>
          }
          showPagination
          totalPages={totalPages}
          onChangePage={onChangeCouponListPage}
          currentPageIndex={currentPage}
          customTitleComponent={<S.TotalCount>total {totalItems}</S.TotalCount>}
        >
          <DataTableHeader header={couponListColumnData} />
          <NewDataTableBody
            columns={couponListColumnData}
            dataList={couponList}
            loading={couponListLoading}
          />
        </DataTableLayout>
      </AccordionBox>
    </>
  );
};

export default CouponList;
